import { createSelector } from 'reselect';

const selectMandates = (s) => s.mandates.items;
const selectMandatesProperty = (s, property) => s.mandates[property];

export const selectMandate = createSelector(
  (_, id) => id,
  selectMandates,
  (s) => selectMandatesProperty(s, 'holdings'),
  (s) => selectMandatesProperty(s, 'kpis'),
  (s) => selectMandatesProperty(s, 'performance'),
  (s) => selectMandatesProperty(s, 'sectorAllocation'),
  (s) => selectMandatesProperty(s, 'geoAllocation'),
  (s) => selectMandatesProperty(s, 'assetClassAllocation'),
  (s) => selectMandatesProperty(s, 'currencies'),
  (s) => selectMandatesProperty(s, 'maxDrawdowns'),
  (s) => selectMandatesProperty(s, 'optimizations'),
  (
    id,
    mandates,
    holdings,
    kpis,
    performance,
    sectorAllocation,
    geoAllocation,
    assetClassAllocation,
    currencies,
    maxDrawdowns,
    optimizations
  ) => {
    const m = mandates.find((c) => c.id === id);
    if (!m) return null;
    const perf = performance[m.id] ?? {};
    return {
      ...m,
      holdings: holdings[m.id] ?? [],
      sectorAllocation: sectorAllocation[m.id] ?? [],
      geoAllocation: geoAllocation[m.id] ?? [],
      assetClassAllocation: assetClassAllocation[m.id] ?? [],
      currencies: currencies[m.id] ?? [],
      kpis: kpis[m.id] ?? {},
      maxDrawdown: maxDrawdowns[m.id] ?? [],
      optimization: optimizations[m.id],
      ...perf,
    };
  }
);

const selectMandatesAlerts = (s) => s.mandates.alerts;

export const selectMandatesAlert = createSelector(
  (_, message) => message,
  selectMandatesAlerts,
  (message, alerts) => {
    return alerts.find((a) => a.message === message);
  }
);
